import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "m-nav-bar-container" }
const _hoisted_2 = { class: "nav-bar-box" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = ["src", "alt"]

import { NIcon } from "naive-ui";
import { computed, nextTick, onMounted, ref, watch } from "vue";
import { Menu, Home, Medkit, PaperPlane, Folder, Map } from "@vicons/ionicons5";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useCalCScreenMinWidth } from "@/composables/useCalcScreenMinWidth";
import { NavMenusList } from "@/constant";
import { MessageAlert } from "@/composables/useMessageAlert";


export default /*@__PURE__*/_defineComponent({
  __name: 'NavBar',
  props: {
    isHome: {
        type: Boolean,
        default: () => {
            return false;
        },
    },
},
  setup(__props) {

const props = __props;

const router = useRouter();
const { screenWinWidth } = useCalCScreenMinWidth();
const store = useStore();

const tabsValue = ref<string>("Home");
const isSrollTopDis = ref<boolean>(false);
const showMenuPopover = ref<boolean>(false);
const showPopover = ref<boolean>(false);
const isShowLoginAndRegisterModal = ref<boolean>(false);
const isShowDoctorAuthenticationModal = ref<boolean>(false);
const showConfirmLoginOutModal = ref<boolean>(false);
const isLogined = computed(() => {
    return store.getters["user/getLoginStatus"];
});
const showLoginModal = computed(() => {
    return store.getters["user/getShowLoginModal"];
});
const userInfo = computed(() => {
    return store.getters["user/getUserInfo"];
});

// 切换tab
const handleNavChange = (value: string | number) => {
    // console.log(value);
    switch (value) {
        case "Home":
            router.push({ path: "/mobile" });
            tabsValue.value = "Home";
            break;
        case "Medical":
            router.push({ path: "/mobile/medical" });
            tabsValue.value = "Medical";
            break;
        case "Posts":
            if (!isLogined.value) {
                MessageAlert("Please login first!");
                nextTick(() => {
                    router.push({ path: "/mobile/login" });
                });
                return false;
            }
            router.push({ path: "/mobile/addpost" });
            tabsValue.value = "Posts";
            break;
        case "Messages":
            if (!isLogined.value) {
                MessageAlert("Please login first!");
                nextTick(() => {
                    router.push({ path: "/mobile/login" });
                });
                return false;
            }
            router.push({ path: "/mobile/message" });
            tabsValue.value = "Messages";
            break;
        case "User":
            if (!isLogined.value) {
                MessageAlert("Please login first!");
                nextTick(() => {
                    router.push({ path: "/mobile/login" });
                });
                return false;
            }
            router.push({ path: "/mobile/usercenter" });
            tabsValue.value = "User";
            break;
    }
};

// onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(NavMenusList), (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["nav-box-sec", { 'sec-active': item.name === tabsValue.value }]),
          key: idx,
          onClick: ($event: any) => (handleNavChange(item.name))
        }, [
          _createVNode(_unref(NIcon), {
            size: "24",
            class: _normalizeClass(["icon-nav", { 'scla-icon': item.name === tabsValue.value }])
          }, {
            default: _withCtx(() => [
              (item.name === tabsValue.value)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: item.actIcon,
                    alt: item.title
                  }, null, 8, _hoisted_4))
                : (_openBlock(), _createElementBlock("img", {
                    key: 1,
                    src: item.icon,
                    alt: item.title
                  }, null, 8, _hoisted_5))
            ]),
            _: 2
          }, 1032, ["class"])
        ], 10, _hoisted_3))
      }), 128))
    ])
  ]))
}
}

})